<template>
  <div class="artwork-box" @click.stop="onAddButtonClick">
    <template v-if="fileId == 0">
      <button
        class="dt-button v2 c5"
        @click.stop="onAddButtonClick"
      >
        + {{ buttonText }}
      </button>
    </template>
    <template v-else>
      <img
        :title="buttonText"
        class="artwork-image"
        @click.stop="onAddButtonClick"
        :src="fileId"
      />
      <img
        @click.stop="onRemoveArtwork"
        src="static/icons/close-icon-accent.svg"
        class="dt-icon v5 close-button h1 s2"
        alt="Close Sidewidnow"
        title="Close Sidewidnow"
      />
    </template>
  </div>
</template>
<script>
import { getBaseUrl } from "../../services/http/http-client";

export default {
  props: {
    fileId: {
      default: 0,
    },
    buttonText: {
      type: String,
    },
  },
  components: {
  },
  mounted: function () {},
  data: function () {
    return {};
  },
  computed: {
    baseURL: function () {
      return getBaseUrl();
    },
  },
  methods: {
    getDataURL: function (data) {
      let reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onload = (e) => {
        console.log("R", e.target.result);
        return e.target.result;
      };
    },
    onClick: function () {},
    onAddButtonClick: function () {
      this.$emit("addSide", true);
    },
    onRemoveArtwork: function () {
      this.$emit("removeSide", true);
    },
    //MARK: Methods
  },
};
</script>
<style lang="scss">
.artwork-box {
  display: grid;
  place-items: center;
  border: 1px solid var(--bc-accent5);
  flex: 1;
  margin: 10px;
  height: calc(100% - 25px);
  position: relative;

  cursor: pointer;

  &:first-child {
    margin-right: 5px;
  }
  &:last-child {
    margin-left: 5px;
  }
  .artwork-image {
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 100%;

    cursor: pointer;
  }

  .dt-icon {
    opacity: 0;
    position: absolute;
    top: 0px;
    right: 0px;
    background: white;
  }

  &:hover {
    .dt-icon {
      opacity: 1;
    }

    border: 1px solid var(--bc-accent55);
  }
}
</style>
